import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

function AgendarServico() {
    const navigate = useNavigate();
    const [service, setService] = useState('');
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Combine date and time
        const dateTime = `${date}T${time}`;

        try {
            await api.post('/appointments', {
                service,
                date: dateTime
            });
            alert('Agendamento realizado com sucesso!');
            navigate('/plataforma/agendamentos');
        } catch (error) {
            console.error(error);
            alert('Erro ao agendar. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="form-container" style={{ width: '100%' }}>
                <h2 style={{ marginBottom: '1.5rem' }}>Novo Agendamento</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Serviço</label>
                        <select value={service} onChange={e => setService(e.target.value)} required>
                            <option value="">Selecione um serviço...</option>
                            <option value="Corte de Cabelo">Corte de Cabelo</option>
                            <option value="Manicure">Manicure</option>
                            <option value="Pedicure">Pedicure</option>
                            <option value="Maquiagem">Maquiagem</option>
                            <option value="Design de Sobrancelhas">Design de Sobrancelhas</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Data</label>
                        <input type="date" value={date} onChange={e => setDate(e.target.value)} required />
                    </div>

                    <div className="form-group">
                        <label>Horário</label>
                        <input type="time" value={time} onChange={e => setTime(e.target.value)} required />
                    </div>

                    <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading}>
                        {loading ? 'Agendando...' : 'Confirmar Agendamento'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AgendarServico;
